import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';

export const useEnabledQuery = () => {
    const isIdle = useSelector((state: RootState) => state.ui.status.isIdle);

    return (localCondition: unknown) => !isIdle && Boolean(localCondition);
};
